/** CNPJ (company) signup is Brazil-only, so "foreign" and CNPJ cannot both be set (RN005). */
export function isCnpjForeignConflict(identityType: string, isForeign: boolean): boolean {
  return identityType === 'cnpj' && isForeign;
}
